import React from "react";
import { withStyles } from "material-ui/styles";
import FreeOpinionTable from "components/ReportDetail/FreeOpinionTable";
import ErrorMessage from "components/ErrorMessage";

const styles = () => ({
  container: {
    padding: 20,
    margin: "20px auto",
    width: 1100
  },
  reportTitle: { fontSize: 30, textAlign: "center" },
  chapter: {
    paddingTop: 70
  },
  chapterTitle: {
    fontSize: 20,
    fontWeight: 600,
    textAlign: "center"
  },
  section: {
    paddingLeft: 20
  },
  sectionTitle: {
    fontWeight: 600,
    display: "inline-block"
  },
  result: {
    marginBottom: 50
  },
  errorMessage: {
    margin: 10
  }
});

class FreeOpinionReport extends React.Component {
  componentWillMount() {
    this.props.fetchFreeOpinionReport();
  }
  componentWillUnmount() {
    this.props.initFreeOpinionReport();
  }
  render() {
    const { classes, freeOpinionReport } = this.props;
    const { freeOpinionList, errors } = freeOpinionReport;
    if (errors.length > 0) {
      return (
        <ErrorMessage messages={errors} className={classes.errorMessage} />
      );
    }
    if (freeOpinionList.length === 0) {
      return null;
    }
    return (
      <div style={{ padding: 30, backgroundColor: "white" }}>
        <div className={classes.reportTitle}>NiserES 調査結果 添付資料</div>
        {/* 自由記入一覧 */}
        <section className={classes.chapter} id="summary">
          <div style={{ fontSize: 20 }}>
            自由記入{freeOpinionList.number}：{freeOpinionList.title}
          </div>
          <div className={classes.result}>
            <FreeOpinionTable
              data={freeOpinionList.data}
              attrTitle={freeOpinionList.attrTitle}
              changeEditable={this.props.changeEditable}
              changeAnswer={this.props.changeAnswer}
              updateAnswer={this.props.updateAnswer}
              deleteAnswer={this.props.deleteAnswer}
            />
          </div>
        </section>
      </div>
    );
  }
}

export default withStyles(styles)(FreeOpinionReport);



// WEBPACK FOOTER //
// ./src/components/ReportDetail/FreeOpinionReport.jsx